import { ReactNode } from 'react';
import { Container, LinkState } from './styles';

interface CardLinkProps {
  name: string;
  colorLeft?: string;
  colorRight?: string;
  children?: ReactNode;
  link?: string;
  soon?: boolean;
  newLink?: boolean;
  stateTitle?: string;
}

const CardLink = ({
  name,
  colorLeft,
  colorRight,
  children,
  link,
  soon,
  newLink,
  stateTitle,
}: CardLinkProps) => {
  return (
    <Container
      href={link}
      target="_blank"
      colorLeft={colorLeft}
      colorRight={colorRight}
    >
      {children}

      <h1 className="card-link-title">{name}</h1>

      <LinkState soon={soon} new={newLink}>
        <h2 className="card-link-soon">{stateTitle}</h2>
      </LinkState>
    </Container>
  );
};

export default CardLink;
